import React, { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

export function PasswordField({ value, onChange, placeholder = "••••••••", required = true, testid = "password-input", className = "input-atia", autoComplete = "current-password" }) {
    const [show, setShow] = useState(false);
    return (
        <div className="relative">
            <input
                type={show ? "text" : "password"}
                className={className + " pr-10"}
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
                required={required}
                autoComplete={autoComplete}
                data-testid={testid}
            />
            <button
                type="button"
                onClick={() => setShow(s => !s)}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-zinc-500 hover:text-zinc-800"
                aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}
                data-testid={testid + "-toggle"}
                tabIndex={-1}
            >
                {show ? <EyeSlash size={16} weight="bold" /> : <Eye size={16} weight="bold" />}
            </button>
        </div>
    );
}

export function TrafficBadge({ value }) {
    const map = {
        verde: { cls: "sev-verde", label: "VERDE" },
        amarillo: { cls: "sev-amarillo", label: "AMARILLO" },
        rojo: { cls: "sev-rojo", label: "ROJO" },
        sin_evaluar: { cls: "sev-sin_evaluar", label: "SIN EVALUAR" },
    };
    const v = map[value] || map.sin_evaluar;
    return (
        <span className={`badge-sev ${v.cls}`} data-testid={`traffic-${value}`}>
            <span className={`traffic-dot traffic-${value}`} />
            {v.label}
        </span>
    );
}

export function SeverityBadge({ value }) {
    return <span className={`badge-sev sev-${value}`} data-testid={`sev-${value}`}>{value?.toUpperCase()}</span>;
}

export function RoleBadge({ role }) {
    return <span className={`role-badge role-${role}`} data-testid={`role-${role}`}>{role}</span>;
}

export function AtiaBrand({ size = "default", invert = false }) {
    const dim = size === "lg" ? 48 : 32;
    return (
        <span className="atia-brand" data-testid="atia-brand" style={{ color: invert ? "#fff" : undefined }}>
            <img src="/brand/atia_logo.png" alt="ATIA" style={{ width: dim, height: dim }} />
            <span className="flex flex-col">
                <span className="atia-brand-text-main" style={{ color: invert ? "#fff" : undefined }}>ATIA</span>
                <span className="atia-brand-text-sub" style={{ color: invert ? "rgba(255,255,255,0.6)" : undefined }}>Construcciones S.A.S.</span>
            </span>
        </span>
    );
}

export function EstadoOrden({ estado }) {
    const map = {
        pendiente: { bg: "#FEF3C7", color: "#92400E", label: "PENDIENTE" },
        en_curso: { bg: "#DBEAFE", color: "#1E40AF", label: "EN CURSO" },
        cerrada: { bg: "#D1FAE5", color: "#065F46", label: "CERRADA" },
    };
    const v = map[estado] || map.pendiente;
    return <span className="badge-sev" style={{ background: v.bg, color: v.color, borderColor: v.bg }}>{v.label}</span>;
}
